import {Axios} from 'services/axios';

export const understandItBetterApi = {
  createOne: async payload => {
    try {
      if (!payload) throw new Error('Section data is required');
      const {entityId, entityType, title, description} = payload;
      if (!entityId) throw new Error('entityId is required');
      if (!entityType) throw new Error('entityType is required');
      if (!title) throw new Error('title is required');
      if (!description) throw new Error('description is required');

      const response = await Axios.post(
        '/understanding-better/create',
        payload,
      );
      if (!response || !response.data)
        throw new Error('Invalid response from server');

      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message || 'Section created successfully',
      };
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.message ||
        'Failed to create section';
      throw new Error(msg);
    }
  },

  // ── GET ALL GROUPED BY ENTITY (list page ke liye) ──────────────────────────
  getAllGrouped: async (options = {}) => {
    try {
      const {entityType = '', status = ''} = options;
      const params = new URLSearchParams();
      if (entityType) params.append('entityType', entityType);
      if (status !== '') params.append('status', status);

      const query = params.toString() ? `?${params.toString()}` : '';
      const response = await Axios.fetch(
        `/understanding-better/getAllGrouped${query}`,
      );
      if (!response || !response.data)
        throw new Error('Invalid response from server');

      return response.data.data || response.data || [];
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.message ||
        'Failed to fetch sections';
      throw new Error(msg);
    }
  },

  // ── GET sections by entity (edit/view page ke liye) ────────────────────────
  getByEntity: async (entityType, entityId) => {
    try {
      if (!entityType) throw new Error('entityType is required');
      if (!entityId) throw new Error('entityId is required');

      const response = await Axios.fetch(
        `/understanding-better/getSectionsByEntity/${entityType}/${entityId}`,
      );
      if (!response || !response.data)
        throw new Error('Invalid response from server');

      return response.data.data || response.data;
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.message ||
        'Failed to fetch sections';
      throw new Error(msg);
    }
  },

  // ── GET single section by ID ───────────────────────────────────────────────
  getById: async id => {
    try {
      if (!id) throw new Error('Section ID is required');

      const response = await Axios.fetch(`/understanding-better/${id}`);
      if (!response || !response.data)
        throw new Error('Invalid response from server');

      const section = response.data.data || response.data;
      if (!section) throw new Error('Section not found');

      return section;
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.message ||
        'Failed to fetch section';
      throw new Error(msg);
    }
  },

  // ── UPDATE section ─────────────────────────────────────────────────────────
  updateOne: async (id, payload) => {
    try {
      if (!id) throw new Error('Section ID is required');
      if (!payload) throw new Error('Section data is required');

      const response = await Axios.put(
        `/understanding-better/update/${id}`,
        payload,
      );
      if (!response || !response.data)
        throw new Error('Invalid response from server');

      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message || 'Section updated successfully',
      };
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.message ||
        'Failed to update section';
      throw new Error(msg);
    }
  },

  // ── DELETE one section ─────────────────────────────────────────────────────
  deleteOne: async id => {
    try {
      if (!id) throw new Error('Section ID is required');

      const response = await Axios.delete(`/understanding-better/delete/${id}`);
      if (!response || !response.data)
        throw new Error('Invalid response from server');

      return {
        success: true,
        message: response.data.message || 'Section deleted successfully',
      };
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.message ||
        'Failed to delete section';
      throw new Error(msg);
    }
  },

  // ── DELETE ALL sections by entity ──────────────────────────────────────────
  deleteAllByEntity: async (entityType, entityId) => {
    try {
      if (!entityType) throw new Error('entityType is required');
      if (!entityId) throw new Error('entityId is required');

      const response = await Axios.delete(
        `/understanding-better/deleteAllByEntity/${entityType}/${entityId}`,
      );
      if (!response || !response.data)
        throw new Error('Invalid response from server');

      return {
        success: true,
        message: response.data.message || 'All sections deleted successfully',
      };
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.message ||
        'Failed to delete sections';
      throw new Error(msg);
    }
  },

  // ── Entity lists ───────────────────────────────────────────────────────────
  getProductList: async () => {
    try {
      const response = await Axios.fetch('/faq/entities/products');
      if (!response || !response.data)
        throw new Error('Invalid response from server');
      return response.data.data || response.data || [];
    } catch (error) {
      throw new Error('Failed to fetch products: ' + error.message);
    }
  },

  getValuePackList: async () => {
    try {
      const response = await Axios.fetch('/faq/entities/valuepacks');
      if (!response || !response.data)
        throw new Error('Invalid response from server');
      return response.data.data || response.data || [];
    } catch (error) {
      throw new Error('Failed to fetch value packs: ' + error.message);
    }
  },

  getQAList: async () => {
    try {
      const response = await Axios.fetch('/faq/entities/plans');
      if (!response || !response.data)
        throw new Error('Invalid response from server');
      return response.data.data || response.data || [];
    } catch (error) {
      throw new Error('Failed to fetch Q&A list: ' + error.message);
    }
  },
};

// import {Axios} from 'services/axios'; // same as subscriptionApi

// export const understandItBetterApi = {
//   // ── CREATE one section ──────────────────────────────────────────────────────
//   createOne: async payload => {
//     try {
//       if (!payload) throw new Error('Section data is required');

//       const {entityId, entityType, title, description} = payload;
//       if (!entityId) throw new Error('entityId is required');
//       if (!entityType) throw new Error('entityType is required');
//       if (!title) throw new Error('title is required');
//       if (!description) throw new Error('description is required');

//       const response = await Axios.post(
//         '/understanding-better/create',
//         payload,
//       );

//       if (!response || !response.data) {
//         throw new Error('Invalid response structure from server');
//       }

//       return {
//         success: true,
//         data: response.data.data || response.data,
//         message: response.data.message || 'Section created successfully',
//       };
//     } catch (error) {
//       console.error('Error creating understand it better section:', error);

//       let errorMessage = 'Failed to create section';
//       if (error.response) {
//         errorMessage =
//           error.response.data?.message ||
//           `Server error: ${error.response.status}`;
//       } else if (error.request) {
//         errorMessage = 'Network error: Unable to reach server';
//       } else {
//         errorMessage = error.message || errorMessage;
//       }

//       throw new Error(errorMessage);
//     }
//   },

//   // ── GET ALL sections (admin, optional ?entityType= filter) ─────────────────
//   getAll: async (options = {}) => {
//     try {
//       const {entityType = '', status = '', page = 1, limit = 10} = options;

//       const params = new URLSearchParams({
//         page: String(page),
//         limit: String(limit),
//       });

//       if (entityType) params.append('entityType', entityType);
//       if (status !== '' && status !== undefined)
//         params.append('status', status);

//       const response = await Axios.fetch(
//         `/understanding-better/getAll?${params}`,
//       );

//       if (!response || !response.data) {
//         throw new Error('Invalid response structure from server');
//       }

//       return response.data.data || response.data;
//     } catch (error) {
//       console.error('Error fetching understand it better sections:', error);

//       let errorMessage = 'Failed to fetch sections';
//       if (error.response) {
//         errorMessage =
//           error.response.data?.message ||
//           `Server error: ${error.response.status}`;
//       } else if (error.request) {
//         errorMessage = 'Network error: Unable to reach server';
//       } else {
//         errorMessage = error.message || errorMessage;
//       }

//       throw new Error(errorMessage);
//     }
//   },

//   // ── GET sections by entity (entityType + entityId) ─────────────────────────
//   getByEntity: async (entityType, entityId) => {
//     try {
//       if (!entityType) throw new Error('entityType is required');
//       if (!entityId) throw new Error('entityId is required');

//       const response = await Axios.fetch(
//         `/understanding-better/getSectionsByEntity/${entityType}/${entityId}`,
//       );

//       if (!response || !response.data) {
//         throw new Error('Invalid response structure from server');
//       }

//       return response.data.data || response.data;
//     } catch (error) {
//       console.error('Error fetching sections by entity:', error);

//       let errorMessage = 'Failed to fetch sections';
//       if (error.response) {
//         if (error.response.status === 404) {
//           errorMessage = 'No sections found for this entity';
//         } else {
//           errorMessage =
//             error.response.data?.message ||
//             `Server error: ${error.response.status}`;
//         }
//       } else if (error.request) {
//         errorMessage = 'Network error: Unable to reach server';
//       } else {
//         errorMessage = error.message || errorMessage;
//       }

//       throw new Error(errorMessage);
//     }
//   },

//   // ── GET single section by ID ───────────────────────────────────────────────
//   getById: async id => {
//     try {
//       if (!id) throw new Error('Section ID is required');

//       const response = await Axios.fetch(`/understanding-better/${id}`);

//       if (!response || !response.data) {
//         throw new Error('Invalid response structure from server');
//       }

//       const section = response.data.data || response.data;
//       if (!section) throw new Error('Section not found');

//       return section;
//     } catch (error) {
//       console.error('Error fetching section by id:', error);

//       let errorMessage = 'Failed to fetch section';
//       if (error.response) {
//         if (error.response.status === 404) {
//           errorMessage = 'Section not found';
//         } else {
//           errorMessage =
//             error.response.data?.message ||
//             `Server error: ${error.response.status}`;
//         }
//       } else if (error.request) {
//         errorMessage = 'Network error: Unable to reach server';
//       } else {
//         errorMessage = error.message || errorMessage;
//       }

//       throw new Error(errorMessage);
//     }
//   },

//   // ── UPDATE section ─────────────────────────────────────────────────────────
//   updateOne: async (id, payload) => {
//     try {
//       if (!id) throw new Error('Section ID is required');
//       if (!payload) throw new Error('Section data is required');

//       const response = await Axios.put(
//         `/understanding-better/update/${id}`,
//         payload,
//       );

//       if (!response || !response.data) {
//         throw new Error('Invalid response structure from server');
//       }

//       return {
//         success: true,
//         data: response.data.data || response.data,
//         message: response.data.message || 'Section updated successfully',
//       };
//     } catch (error) {
//       console.error('Error updating section:', error);

//       let errorMessage = 'Failed to update section';
//       if (error.response) {
//         errorMessage =
//           error.response.data?.message ||
//           `Server error: ${error.response.status}`;
//       } else if (error.request) {
//         errorMessage = 'Network error: Unable to reach server';
//       } else {
//         errorMessage = error.message || errorMessage;
//       }

//       throw new Error(errorMessage);
//     }
//   },

//   // ── DELETE one section ─────────────────────────────────────────────────────
//   deleteOne: async id => {
//     try {
//       if (!id) throw new Error('Section ID is required');

//       const response = await Axios.delete(`/understanding-better/delete/${id}`);

//       if (!response || !response.data) {
//         throw new Error('Invalid response structure from server');
//       }

//       return {
//         success: true,
//         message: response.data.message || 'Section deleted successfully',
//       };
//     } catch (error) {
//       console.error('Error deleting section:', error);

//       let errorMessage = 'Failed to delete section';
//       if (error.response) {
//         if (error.response.status === 404) {
//           errorMessage = 'Section not found';
//         } else {
//           errorMessage =
//             error.response.data?.message ||
//             `Server error: ${error.response.status}`;
//         }
//       } else if (error.request) {
//         errorMessage = 'Network error: Unable to reach server';
//       } else {
//         errorMessage = error.message || errorMessage;
//       }

//       throw new Error(errorMessage);
//     }
//   },

//   // ── DELETE ALL sections by entity ──────────────────────────────────────────
//   deleteAllByEntity: async (entityType, entityId) => {
//     try {
//       if (!entityType) throw new Error('entityType is required');
//       if (!entityId) throw new Error('entityId is required');

//       const response = await Axios.delete(
//         `/understanding-better/deleteAllByEntity/${entityType}/${entityId}`,
//       );

//       if (!response || !response.data) {
//         throw new Error('Invalid response structure from server');
//       }

//       return {
//         success: true,
//         message: response.data.message || 'All sections deleted successfully',
//       };
//     } catch (error) {
//       console.error('Error deleting all sections by entity:', error);

//       let errorMessage = 'Failed to delete sections';
//       if (error.response) {
//         if (error.response.status === 404) {
//           errorMessage = 'No sections found for this entity';
//         } else {
//           errorMessage =
//             error.response.data?.message ||
//             `Server error: ${error.response.status}`;
//         }
//       } else if (error.request) {
//         errorMessage = 'Network error: Unable to reach server';
//       } else {
//         errorMessage = error.message || errorMessage;
//       }

//       throw new Error(errorMessage);
//     }
//   },

//   // ── Entity lists — product / valuepack / question_answer ───────────────────
//   getProductList: async () => {
//     try {
//       const response = await Axios.fetch('/faq/entities/products');

//       if (!response || !response.data) {
//         throw new Error('Invalid response structure from server');
//       }

//       return response.data.data || response.data || [];
//     } catch (error) {
//       console.error('Error fetching product list:', error);
//       throw new Error('Failed to fetch products: ' + error.message);
//     }
//   },

//   getValuePackList: async () => {
//     try {
//       const response = await Axios.fetch('/faq/entities/valuepacks');

//       if (!response || !response.data) {
//         throw new Error('Invalid response structure from server');
//       }

//       return response.data.data || response.data || [];
//     } catch (error) {
//       console.error('Error fetching value pack list:', error);
//       throw new Error('Failed to fetch value packs: ' + error.message);
//     }
//   },

//   getQAList: async () => {
//     try {
//       const response = await Axios.fetch('/faq/entities/plans');

//       if (!response || !response.data) {
//         throw new Error('Invalid response structure from server');
//       }

//       return response.data.data || response.data || [];
//     } catch (error) {
//       console.error('Error fetching Q&A list:', error);
//       throw new Error('Failed to fetch Q&A list: ' + error.message);
//     }
//   },
//   getAllGrouped: async () => {
//     try {
//       const response = await Axios.fetch('/understanding-better/getAllGrouped');

//       if (!response || !response.data) {
//         throw new Error('Invalid response structure from server');
//       }

//       return response.data.data || response.data || [];
//     } catch (error) {
//       console.error('Error fetching grouped sections:', error);
//       throw new Error('Failed to fetch sections: ' + error.message);
//     }
//   },
// };
